import { Component, OnInit } from '@angular/core';
import { APIServiceService } from 'src/app/api/apiservice.service';

@Component({
  selector: 'ubc-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  constructor(
    private apiService: APIServiceService
  ) { }

  ngOnInit(): void {
  }

  async reindexCustomersClicked(){
    await this.apiService.customer.reindex()
  }

}
